import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Animated, Image, ScrollView } from 'react-native';
import Storage from '../../../utils/Storage';
import { colores, fuentes, spacing } from '../../../styles/variablesCss';
import { Platform, DeviceEventEmitter } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useCart } from '../../../context/CartContext';

const SelecSuc = ({ onClose, onSelect }) => {
  const { cargarProductosCarrito, setSucursalAnterior } = useCart();
  const [ciudadNom, setCiudadNom] = useState(null);
  const [ciudadObj, setCiudadObj] = useState(null);
  // Paso explícito para forzar siempre preguntar primero la ciudad
  const [step, setStep] = useState('city'); // 'city' | 'sucursal'
  const [selectedSubBranch, setSelectedSubBranch] = useState(null);
  
  // Estado para controlar responsividad
  const [windowWidth, setWindowWidth] = useState(
    Platform.OS === 'web' && typeof window !== 'undefined' ? window.innerWidth : 768
  );
  const isMobile = windowWidth < 768;
  
  // Mapping for cities and branches according to requirements
  const cityMapping = {
    'Rafaela': 1,
    'Bella Italia': 1,
    'Susana': 1,
    'Pte. Roca': 1,
    'San Francisco': 2,
    'Frontera': 2
  };

  // Mostrar selector de ciudades solo cuando estamos en el paso 'city'
  const showCityChooser = step === 'city';
  
  // Mapping de códigos postales para cada ciudad
  const postalCodeMapping = {
    'Rafaela': '2300',
    'Bella Italia': '2301.9',
    'Susana': '2301',
    'Pte. Roca': '2301.6',
    'San Francisco': '2400',
    'Frontera': '2400'
  };

  // Branch address to branch number mapping
  const branchNumberMapping = {
    'Bv. Guillermo Lehmann 425': 1,
    'Av. Roque Sáenz Peña 321': 4,
    '25 de Mayo 1129': 6,
  };
  
  const branchMapping = {
    'Rafaela': 'Bv. Guillermo Lehmann 425',
    'Bella Italia': 'Av. Roque Sáenz Peña 321',
    'Susana': 'Av. Roque Sáenz Peña 321',
    'Pte. Roca': 'Av. Roque Sáenz Peña 321',
    'San Francisco': '25 de Mayo 1129',
    'Frontera': '25 de Mayo 1129'
  };

  const branches = [
    { id: 'rafaela', name: 'Rafaela' },
    { id: 'san-francisco', name: 'San Francisco' },
    { id: 'bella-italia', name: 'Bella Italia' },
    { id: 'susana', name: 'Susana' },
    { id: 'pte-roca', name: 'Pte. Roca' },
    { id: 'frontera', name: 'Frontera' }
  ];

  const subBranches = [
    { address: 'Bv. Guillermo Lehmann 425', number: 1 },
    { address: 'Av. Roque Sáenz Peña 321', number: 4 }
  ];

  // Volver al paso de selección de ciudad (para mobile cuando Rafaela)
  const handleBackToCities = () => {
    setCiudadNom(null);
    setCiudadObj(null);
    setSelectedSubBranch(null);
    setStep('city');
  };

  // Listener para cambios de tamaño de ventana
  useEffect(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  // Load saved selections from storage on component mount
  useEffect(() => {
    const loadSavedSelections = async () => {
      try {
        const savedBranch = await Storage.getItem('ciudadNom');
        const savedSubBranch = await Storage.getItem('selectedSubBranch');
        
        if (savedBranch) {
          const branch = branches.find(b => b.name === savedBranch);
          if (branch) {
            setCiudadNom(savedBranch);
            setCiudadObj(branch);
            
            if (savedSubBranch) {
              // Find the matching sub-branch object
              const matchingSubBranch = subBranches.find(sb => sb.address === savedSubBranch);
              if (matchingSubBranch) {
                setSelectedSubBranch(savedSubBranch);
              }
            }
          }
        }
      } catch (error) {
        console.error('Error loading saved selections:', error);
      }
    };
    
    loadSavedSelections();
  }, []);
  
  // Save selections to storage
  const saveSelectionsToStorage = async (branchName, subBranchName) => {
    try {
      // Guardar la sucursal actual antes de cambiarla
      const sucursalActual = await Storage.getItem('sucursalId');
      const ciudadActual = await Storage.getItem('ciudadNom');
      const subBranchActual = await Storage.getItem('selectedSubBranch');
      
      if (sucursalActual && ciudadActual) {
        setSucursalAnterior({
          sucursalId: sucursalActual,
          ciudadNom: ciudadActual,
          selectedSubBranch: subBranchActual || ''
        });
      }
      
      await Storage.setItem('ciudadNom', branchName);
      
      if (subBranchName) {
        await Storage.setItem('selectedSubBranch', subBranchName);
      }
      
      // Save city and branch IDs according to mapping
      const ciudadId = cityMapping[branchName] || '';
      await Storage.setItem('ciudad', ciudadId.toString());
      
      // Guardar el código postal de la ciudad
      const codigoPostal = postalCodeMapping[branchName] || '';
      await Storage.setItem('codigoPostal', codigoPostal);
      
      let branchAddress = '';
      if (branchName === 'Rafaela' && subBranchName) {
        branchAddress = subBranchName;
      } else {
        branchAddress = branchMapping[branchName] || '';
      }
      
      // Get branch number from address
      const sucursalId = branchNumberMapping[branchAddress] || '';
      
      await Storage.setItem('sucursalId', sucursalId.toString());
      
      // Guardar datos adicionales para Retiro.js
      const pinguino = `Pingüino ${sucursalId}`;
      await Storage.setItem('pinguino', pinguino);
      await Storage.setItem('ciudadNom', branchName);
      
      // Formatear teléfono según sucursal - convertir a string para comparación
      const sucursalIdStr = sucursalId.toString();
      let telefono = '';
      
      if (sucursalIdStr === '4') {
        telefono = 'Tel: (03492) 506104';
      } else if (sucursalIdStr === '1') {
        telefono = 'Tel: (03492) 506101';
      } else if (sucursalIdStr === '6') {
        telefono = 'Tel: (0356) 434147';
      } else {
        telefono = 'Tel: Consultar';
      }
      
      await Storage.setItem('sucursalDeRetiro', telefono);
      
      // Disparar eventos personalizados para notificar cambios
      // Esperamos un momento para asegurar que Storage.setItem haya terminado
      if (Platform.OS === 'web' && typeof window !== 'undefined') {
        setTimeout(() => {
          // Disparar evento para ciudadNom
          window.dispatchEvent(new CustomEvent('localStorageChange', {
            detail: { key: 'ciudadNom', newValue: branchName }
          }));
          
          // Disparar evento para sucursalId
          window.dispatchEvent(new CustomEvent('localStorageChange', {
            detail: { key: 'sucursalId', newValue: sucursalId.toString() }
          }));
          
          // Disparar evento para selectedSubBranch
          if (subBranchName) {
            window.dispatchEvent(new CustomEvent('localStorageChange', {
              detail: { key: 'selectedSubBranch', newValue: subBranchName }
            }));
          }
          
          // Recargar el carrito después de cambiar la sucursal
          // para verificar disponibilidad de productos en la nueva sucursal
          setTimeout(() => {
            cargarProductosCarrito();
          }, 100);
        }, 50);
      } else {
        // En móvil, emitir evento global para notificar cambio de sucursal
        // Dejar un pequeño delay para asegurar writes en Storage
        setTimeout(() => {
          try {
            DeviceEventEmitter.emit('sucursalChanged', { key: 'sucursalId', newValue: sucursalId.toString() });
          } catch (e) {
            
          }
          // También recargar carrito
          setTimeout(() => {
            cargarProductosCarrito();
          }, 100);
        }, 50);
      }
      
    } catch (error) {
      console.error('Error saving selections to storage:', error);
    }
  };

  const handleBranchSelect = (branch) => {
    setCiudadNom(branch.name);
    setCiudadObj(branch);

    // Si NO es Rafaela, resolvemos en un paso
    if (branch.name !== 'Rafaela') {
      let subBranchToSelect = null;
      let branchNumber = null;

      if (['Susana', 'Bella Italia', 'Pte. Roca'].includes(branch.name)) {
        subBranchToSelect = 'Av. Roque Sáenz Peña 321';
        branchNumber = 4; // Branch number for Av. Roque Sáenz Peña
      } else if (['San Francisco', 'Frontera'].includes(branch.name)) {
        subBranchToSelect = '25 de Mayo 1129';
        branchNumber = 6; // Branch number for 25 de Mayo
      }
      
      // Save to localStorage
      saveSelectionsToStorage(branch.name, subBranchToSelect);
      
      onSelect(branch.name, subBranchToSelect, branchNumber);
      onClose();
      return;
    }

    // Si es Rafaela y estamos en mobile, pasamos al paso de sucursal
    if (isMobile && branch.name === 'Rafaela') {
      setStep('sucursal');
    }
  };

  const handleSubBranchSelect = (subBranch) => {
    // Update selected sub-branch state
    setSelectedSubBranch(subBranch.address);
    
    // Save to localStorage
    saveSelectionsToStorage(ciudadNom, subBranch.address);
    
    // Pass branch number along with other info
    onSelect(ciudadNom, subBranch.address, subBranch.number);
    onClose();
  };

  // Estilos dinámicos responsivos
  const dynamicStyles = {
    container: {
      ...styles.container,
      padding: isMobile ? 15 : 20,
    },
    title: {
      ...styles.title,
      fontSize: isMobile ? 14 : 18,
    },
    instructionText: {
      ...styles.instructionText,
      fontSize: isMobile ? 16 : 18,
      marginBottom: isMobile ? 15 : 25,
    },
    branchesContainer: {
      ...styles.branchesContainer,
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'stretch' : 'center',
    },
    branchButton: {
      ...styles.branchButton,
      width: isMobile ? '100%' : 'auto',
      marginVertical: isMobile ? 5 : 0,
    },
    subBranchesContainer: {
      ...styles.subBranchesContainer,
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'center' : 'flex-start',
    },
    subBranchCard: {
      ...styles.subBranchCard,
      width: isMobile ? '90%' : '47%',
      marginBottom: isMobile ? 15 : 0,
    },
  };

  return (
    <View style={dynamicStyles.container}>
      <View style={styles.header}>
        <View style={styles.titleContainer}>
          <MaterialCommunityIcons 
            name="map-marker-radius" 
            size={isMobile ? 20 : 24} 
            color={colores.rojo} 
            style={styles.storeIcon} 
          />
          <Text style={dynamicStyles.title}>{showCityChooser ? 'SELECCIONE CIUDAD' : 'SELECCIONE SUCURSAL'}</Text>
        </View>
        <TouchableOpacity onPress={onClose} style={styles.closeButton}>
          <Text style={styles.closeButtonText}>X</Text>
        </TouchableOpacity>
      </View>

      <ScrollView 
        style={styles.scrollContent}
        showsVerticalScrollIndicator={true}
        contentContainerStyle={styles.scrollContentContainer}
      >
        <Text style={dynamicStyles.instructionText}>
          {showCityChooser ? 'Elegí el lugar de entrega de tu pedido:' : 'Elegí la sucursal para tu pedido:'}
        </Text>
        {(!showCityChooser && isMobile) && (
          <TouchableOpacity style={styles.changeCityButton} onPress={handleBackToCities} activeOpacity={0.7}>
            <MaterialCommunityIcons name="chevron-left" size={16} color={colores.rojo} />
            <Text style={styles.changeCityText}>Cambiar ciudad</Text>
          </TouchableOpacity>
        )}
      
      {showCityChooser && (
        <View style={dynamicStyles.branchesContainer}>
          {branches.map((branch) => (
            <TouchableOpacity
              key={branch.id}
              style={[
                dynamicStyles.branchButton,
                ciudadObj && ciudadObj.id === branch.id && styles.selectedButton,
              ]}
              onPress={() => handleBranchSelect(branch)}
              activeOpacity={0.7}
            >
              <View style={styles.branchButtonContent}>
                <MaterialCommunityIcons 
                  name="map-marker" 
                  size={16} 
                  color={ciudadObj && ciudadObj.id === branch.id ? colores.blanco : colores.rojo} 
                  style={styles.branchIcon} 
                />
                <Text style={[
                  styles.branchText,
                  ciudadObj && ciudadObj.id === branch.id && styles.selectedText
                ]}>
                  {branch.name}
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      )}

      {ciudadNom === 'Rafaela' && (isMobile ? step === 'sucursal' : true) && (
        <>
          <View style={styles.divider}>
            <View style={styles.line} />
            <Text style={styles.subtitle}>Seleccione sucursal</Text>
            <View style={styles.line} />
          </View>
          <View style={dynamicStyles.subBranchesContainer}>
            {subBranches.map((subBranch, index) => (
              <TouchableOpacity
                key={subBranch.address}
                style={[
                  dynamicStyles.subBranchCard,
                  selectedSubBranch === subBranch.address && styles.selectedSubBranchCard,
                  !isMobile && index === 0 && { marginRight: 15 }
                ]}
                onPress={() => handleSubBranchSelect(subBranch)}
                activeOpacity={0.8}
              >
                <View style={styles.branchBadge}>
                  <Text style={styles.branchNumberBadge}>{subBranch.number}</Text>
                </View>
                <Text style={[
                  styles.branchNameText,
                  selectedSubBranch === subBranch.address && styles.branchNameTextSelected
                ]}>
                  PINGÜINO {subBranch.number}
                </Text>
                <View style={styles.addressContainer}>
                  <MaterialCommunityIcons name="map-marker" size={16} color={colores.rojo} style={{marginRight: 4}} />
                  <Text style={styles.branchAddressText}>
                    {subBranch.address}
                  </Text>
                </View>
                <View style={styles.phoneContainer}>
                  <MaterialCommunityIcons name="phone" size={16} color={colores.rojo} style={{marginRight: 4}} />
                  <Text style={styles.branchPhoneText}>
                    {subBranch.number === 3 ? '(03492) 506101' : '(03492) 506104 - 504000'}
                  </Text>
                </View>
              </TouchableOpacity>
            ))}
          </View>
        </>
      )}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 20,
    backgroundColor: 'white',
    maxHeight: Platform.OS === 'web' ? '90vh' : '100%',
    ...(Platform.OS === 'web' ? {
      position: 'relative',
      zIndex: 1000001,
      maxWidth: 640,
      marginTop: 0,
      marginBottom: 0,
      marginHorizontal: 'auto',
      borderRadius: 10,
      boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
    } : {
      position: 'relative',
      zIndex: 10004,
    }),
  },
  scrollContent: {
    flex: 1,
  },
  scrollContentContainer: {
    paddingBottom: 20,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 30,
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  storeIcon: {
    marginRight: 10,
  },
  title: {
    fontSize: 18,
    fontFamily: fuentes.bold,
    color: colores.rojo,
    textTransform: 'uppercase',
  },
  closeButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    ...(Platform.OS === 'web' ? {
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      ':hover': {
        transform: 'translateX(3px)'
      }
    } : {}),
  },
  closeButtonText: {
    //color: colores.rojo,
    fontFamily: fuentes.medium,
    fontSize: 14,
  },
  instructionText: {
    fontSize: 18,
    fontFamily: fuentes.medium,
    color: colores.textoPrincipal,
    marginBottom: 25,
    textAlign: 'center',
  },
  divider: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 30,
    marginBottom: 25,
    width: '100%',
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: '#eaeaea',
  },
  subtitle: {
    fontSize: 16,
    fontFamily: fuentes.medium,
    color: colores.textoPrincipal,
    marginHorizontal: 15,
    textAlign: 'center',
  },
  changeCityButton: {
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginBottom: 10,
  },
  changeCityText: {
    color: colores.rojo,
    fontFamily: fuentes.medium,
    fontSize: 14,
  },
  branchesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: spacing.md,
    marginBottom: spacing.lg,
  },
  subBranchesContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
    width: '100%',
  },
  branchButton: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 50,
    backgroundColor: colores.blanco,
    minWidth: 120,
    margin: 5,
    elevation: 2,
    ...(Platform.OS === 'web' ? {
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
      }
    } : {}),
  },
  branchButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  branchIcon: {
    marginRight: 5,
  },
  selectedButton: {
    backgroundColor: colores.rojo,
    borderColor: colores.rojo,
    elevation: 3,
    ...(Platform.OS === 'web' ? {
      boxShadow: '0 4px 8px rgba(220,20,20,0.2)'
    } : {}),
  },
  branchText: {
    color: colores.textoPrincipal,
    fontSize: 14,
    fontFamily: fuentes.medium,
  },
  selectedText: {
    color: colores.blanco,
    fontFamily: fuentes.medium,
  },
  subBranchCard: {
    width: '47%',
    padding: 20,
    borderRadius: 12,
    backgroundColor: '#ffffff',
    alignItems: 'center',
    elevation: 4,
    position: 'relative',
    overflow: 'visible',
    ...(Platform.OS === 'web' ? {
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      ':hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 15px rgba(0,0,0,0.12)'
      }
    } : {}),
  },
  selectedSubBranchCard: {
    borderWidth: 2,
    borderColor: colores.rojo,
    ...(Platform.OS === 'web' ? {
      boxShadow: `0 8px 16px rgba(${parseInt(colores.rojo.slice(1, 3), 16)}, ${parseInt(colores.rojo.slice(3, 5), 16)}, ${parseInt(colores.rojo.slice(5, 7), 16)}, 0.2)`
    } : {}),
  },
  branchBadge: {
    position: 'absolute',
    top: -10,
    backgroundColor: colores.rojo,
    width: 30,
    height: 30,
    borderRadius: 15,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 2,
    ...(Platform.OS === 'web' ? {
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    } : {}),
  },
  branchNumberBadge: {
    color: '#fff',
    fontSize: 14,
    fontFamily: fuentes.bold,
  },
  branchNameText: {
    fontSize: 18,
    fontFamily: fuentes.bold,
    color: '#000',
    marginBottom: 15,
    marginTop: 10,
    textAlign: 'center',
  },
  branchNameTextSelected: {
    color: colores.rojo,
  },
  addressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    width: '100%',
    paddingHorizontal: 5,
  },
  phoneContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 5,
  },
  branchAddressText: {
    fontSize: 13,
    fontFamily: fuentes.regular,
    color: '#333',
    flex: 1,
  },
  branchPhoneText: {
    fontSize: 13,
    fontFamily: fuentes.regular,
    color: '#333',
    flex: 1,
  }
});

export default SelecSuc;